import { render, staticRenderFns } from "./UmsApplicationPasswordChanger.vue?vue&type=template&id=00846e8a&"
import script from "./UmsApplicationPasswordChanger.vue?vue&type=script&lang=js&"
export * from "./UmsApplicationPasswordChanger.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports